module.exports = __webpack_public_path__ + "static/media/joyce_img.ac1cb841.svg";